import React, { useState } from 'react'
import * as R from 'ramda'
import { useDispatch } from 'react-redux'
import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { FormattedMessage, useIntl } from 'react-intl'

import { formatDate } from 'commons/date'
import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'
import { useSubscription } from 'commons/useSubscription'
import ConfirmationDialog from 'app/components/ConfirmationDialog'
import SecondaryButton from 'app/components/buttons/SecondaryButton'
import { ButtonWithLoading } from 'app/components/FormsyHelperComponent'
import {
  useIsPlaceExpired,
  useIsPlaceInRechargeablePeriod,
} from 'commons/useIsPlaceRestricted'

import { usePlanBillingContext } from '../usePlanBillingContext'

const useStyles = makeStyles((theme) => ({
  buttonDisable: {
    backgroundColor: 'rgba(204, 204, 204, 1) !important',
    color: 'rgba(171, 171, 171, 1) !important',
  },
}))

export const PlanBillingCancelPlan = () => {
  const classes = useStyles()
  const reduxDispatch = useDispatch()
  const { formatMessage } = useIntl()
  const subscription = useSubscription()
  const { refetch } = usePlanBillingContext()

  const isPlaceInRechargeablePeriod = useIsPlaceInRechargeablePeriod()
  const isPlaceExpired = useIsPlaceExpired()

  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isShowConfirmCancelPlanDialog, setIsShowConfirmCancelPlanDialog] =
    useState(false)

  const handleCloseConfirmCancelPlanDialog = () => {
    setIsShowConfirmCancelPlanDialog(false)
  }

  const handleCancelPlan = async () => {
    setIsSubmitting(true)
    try {
      await effects.apis.cancelPlan()
      refetch()
    } catch (error) {
      reduxDispatch(MessageAlert.showNetworkError(formatMessage)(error))
    } finally {
      setIsShowConfirmCancelPlanDialog(false)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <Button
        onClick={() => setIsShowConfirmCancelPlanDialog(true)}
        variant="contained"
        disabled={isPlaceInRechargeablePeriod || isPlaceExpired}
        className={
          isPlaceInRechargeablePeriod || isPlaceExpired
            ? classes.buttonDisable
            : 'bg-white self-start border-solid border-1 border-gray-600 text-gray-800 shadow-0'
        }
        data-testid="cancelPlanButton"
      >
        {formatMessage({
          id: 'planAndBilling.cancelSubscription.label',
        })}
      </Button>

      <ConfirmationDialog
        open={isShowConfirmCancelPlanDialog}
        maxWidth="xs"
        title={formatMessage({
          id: 'planAndBilling.cancelPlan.label',
        })}
        body={
          <FormattedMessage
            id="planAndBilling.cancelPlan.confirmDialog.body.label"
            values={{
              date: formatDate(R.prop('nextBillingDate', subscription)),
            }}
          />
        }
        CancelButton={
          <SecondaryButton
            labelId="action.goBack"
            disabled={isSubmitting}
            onClick={handleCloseConfirmCancelPlanDialog}
          />
        }
        ConfirmButton={
          <ButtonWithLoading
            isLoading={isSubmitting}
            disabled={isSubmitting}
            onClick={handleCancelPlan}
            labelId="action.confirm"
          ></ButtonWithLoading>
        }
      />
    </>
  )
}
